
































import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import Utils from "@/utils/utils";
import { CameraImage } from "@/store/modules/CameraImage/interface";

export default Vue.extend({
  name: "DeviceTensionCard",
  components: { StandartCard, LineChart },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    datas: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      datacollection: {},
      colors: ["#17a9e1"]
    };
  },
  mounted(): void {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labels,
        datasets: this.format_data_dataset
      };
    },
    datas_per_hours(): Array<number> {
      const datas_per_day: any = {};
      (this.datas as Array<CameraImage>).forEach((data) => {
        const label = Utils.transformDateToYMDHMS(data.d_h_process);
        datas_per_day[label] = this.calculate_battery_level(data.tension);
      });
      return Object.values(datas_per_day);
    },
    calculate_battery_level(tension: string): number {
      const tension_max = 12.6;
      try {
        const tension_number = parseFloat(tension.split("V")[0]);
        if (isNaN(tension_number)) return NaN;
        if (tension_number <= 9) return NaN;
        return Math.round(((tension_number - 9) / (tension_max - 9)) * 100);
      } catch (e) {
        return NaN;
      }
    }
  },
  computed: {
    format_data_dataset(): Array<any> {
      const dataset: Array<any> = [];
      dataset.push({
        label: "Batterie en %",
        data: this.datas_per_hours(),
        borderColor: this.colors[0],
        borderWidth: 1,
        fill: false
      });
      return dataset;
    }
  },
  watch: {
    labels: {
      handler(): void {
        this.fillData();
      }
    }
  }
});
